<template>
    <website-page no-sub-menu>
        <div id="blog" class="top-section gradient-primary">
            <div class="col-md-5 mx-auto my-4">
                <h1 class="text-white">
                    <span v-tr>Blog|Blog</span>
                </h1>
                <p class="lead" v-tr>The latest news about Eye-In Media!|Les dernières nouvelles sur Eye-In Media!</p>
            </div>
        </div>
        <div class="page py-3">
            <blog-posts source="eye-in-media"></blog-posts>
        </div>
    </website-page>
</template>

<script>

    import BlogPosts from "../../vue-components/components/blog-posts";
    export default {
        name: `blog`,
        components: {BlogPosts}
    }
</script>

<style lang="scss" scoped>
    @import "../assets/style/bootstrap-theme";

    #blog {
        background-color: #000;
        color: white;
        //background-image: url('../assets/img/poster.jpg');
        background-size: cover;
        padding: 40px;
    }
</style>
